/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * Gas only. The unit this register records in: M3 = cubic metres, HCF = hundreds of cubic feet (the standard UK imperial register, ×2.83 to m³), THCF = thousands of cubic feet (×28.3), TCM3 = thousands of cubic metres (×1000, Junifer's thm³). Falls back to the request-level gasUnitType when omitted.
 * @nullable
 */
export type EstimatorRegisterInputUnit =
  | (typeof EstimatorRegisterInputUnit)[keyof typeof EstimatorRegisterInputUnit]
  | null

export const EstimatorRegisterInputUnit = {
  M3: "M3",
  HCF: "HCF",
  THCF: "THCF",
  TCM3: "TCM3",
} as const
